import { StoryblokServerComponent } from '@storyblok/react/rsc';
import Header from '@/components/Header';
import { bannerIdFor } from '@/lib/helpers';
import { getRequestContext } from '@/lib/request-context';

const HeaderServer = ({ blok, languageLinks }) => {
  const navBodies = {};

  for (const item of blok.nav_items || []) {
    const sections = [
      ...(item.dropdown_sections || []),
      ...(item.dropdown_rows || []).flatMap((row) => row.sections || []),
    ];
    for (const section of sections) {
      for (const link of section.links || []) {
        if (!link.body?.length) continue;
        navBodies[link._uid] = link.body.map((nestedBlok) => (
          <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
        ));
      }
    }
  }

  // The banner's id comes from its text, so changing the message re-shows it to
  // anyone who dismissed the old one. The cookie itself is read in the route: this
  // component sits in the Storyblok registry, which StoryblokProvider pulls into the
  // client bundle, so it must not touch next/headers. The route hands it over
  // through request context instead.
  const bannerId = bannerIdFor(blok.banner_text);
  const bannerDismissed = !!bannerId && getRequestContext().bannerDismissedId === bannerId;

  return (
    <Header
      blok={blok}
      navBodies={navBodies}
      bannerId={bannerId}
      bannerDismissed={bannerDismissed}
      languageLinks={languageLinks}
    />
  );
};

export default HeaderServer;
